import { textLengths } from "../../redux/Types";

export const ValidatePlaylistCategory = (data) => {
    let errors = {}

    if (data) {
        if (!data.name) {
            errors.name = "Should not be empty";
        } else if (data.name && data.name.length > textLengths.TEXT) {
            errors.name = "Sorry, the name you entered is too long. Please try a shorter name";
        }

        if (data.desc && data.desc.length > textLengths.TEXT) {
            errors.desc = "Sorry, the description you entered is too long. Please try a shorter description";
        }
    }


    if (Object.entries(errors).length === 0) {
        return null;
    } else {
        return errors;
    }
}